<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="finalVisible"
    title="人工核销"
    width="400px"
  >
    <div class="dialog-content">
      仅线下处理售后退款的订单使用这个人工核销，确认和客户达成一致？
    </div>
    <div class="remark-box">
      <span>备注：</span>
      <el-input v-model="remark" :maxlength="200" :rows="4" class="remark" placeholder="请输入备注" type="textarea"/>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button :disabled="loading" :loading="loading" type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ddCouponUseInfoManualVerificationDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 计算属性
    finalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.remark = '';
      }
    }
  },
  data() {
    return {
      // 备注
      remark: ''
    };
  },
  methods: {
    handleConfirm() {
      if (!this.remark) {
        this.$message.error('请输入备注');
        return;
      }
      // 确定按钮的处理逻辑
      this.$emit('confirm', this.remark);
    },
    handleCancel() {
      // 取消按钮的处理逻辑
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style scoped>
.remark-box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  .remark {
    display: flex;
    flex: 1;
    margin-top: 0;
  }
}

.dialog-content {
  font-size: 16px;
  color: #333;
  text-align: center;
  margin: 20px 0;
}

.remark {
  font-size: 16px;
  color: #333;
  margin: 20px 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end; /* 将按钮对齐到右边 */
  padding: 10px 0; /* 添加一些顶部和底部的间距 */
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/ddCouponExchange/ddCouponUseInfo/components/ddCouponUseInfoManualVerificationDialog.vue